module.exports = __webpack_public_path__ + "static/media/sex-photo-1-2-x.41a7d76b.jpg";